/**
 * The web half of the hospitality vertical.
 *
 * `messages` is empty by design: `TranslationKey` derives from the base
 * catalogue's literal type, so a key that exists only here could not be
 * passed to `t()`. Strings live in `i18n.ts`, which also keeps one place to
 * audit for DGI language compliance.
 */
import { lazy } from 'react';
import type { SectorModuleUi } from '../types';
import { LazyPage } from '../../components/layout/LazyPage';
import { hospitaliteNav } from './nav';

const TablesPage = lazy(() => import('../../pages/hospitalite/TablesPage'));
const MenuPage = lazy(() => import('../../pages/hospitalite/MenuPage'));
const StationPage = lazy(() => import('../../pages/hospitalite/StationPage'));
const RoomsPage = lazy(() => import('../../pages/hospitalite/RoomsPage'));
const StayPage = lazy(() => import('../../pages/hospitalite/StayPage'));
const IndicatorsPage = lazy(() => import('../../pages/hospitalite/IndicatorsPage'));

export const hospitaliteUi: SectorModuleUi = {
  code: 'HOSPITALITE',
  nav: hospitaliteNav,
  routes: [
    {
      path: 'plan-de-salle',
      element: (
        <LazyPage>
          <TablesPage />
        </LazyPage>
      ),
    },
    {
      path: 'carte',
      element: (
        <LazyPage>
          <MenuPage />
        </LazyPage>
      ),
    },
    {
      path: 'postes',
      element: (
        <LazyPage>
          <StationPage />
        </LazyPage>
      ),
    },
    {
      path: 'chambres',
      element: (
        <LazyPage>
          <RoomsPage />
        </LazyPage>
      ),
    },
    {
      path: 'sejours',
      element: (
        <LazyPage>
          <StayPage />
        </LazyPage>
      ),
    },
    {
      path: 'indicateurs',
      element: (
        <LazyPage>
          <IndicatorsPage />
        </LazyPage>
      ),
    },
  ],
  messages: {},
};
